module.exports = __webpack_public_path__ + "img/27_37.3b896ef7.png";